import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u539503415/domains/centronics.com.sa/public_html/.builds/source/techsolutions_pro/src/app/contact/components/ContactInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u539503415/domains/centronics.com.sa/public_html/.builds/source/techsolutions_pro/src/components/common/Header.tsx");
